import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { IntraOne_DatasourceService } from './IntraOne.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.IntraOne = this.injector.get(IntraOne_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public IntraOne: IntraOne_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

